import React from "react";

const Footer = () => {
  return (
    <footer id="contact">
      <div className="contact-section">
        <h3>Contact</h3>
        <div className="contact-links">
          <a
            href="https://x.com/Cserpi4"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/x.png`}
              alt="X (Twitter)"
              className="contact-image"
            />
          </a>
          <a
            href="https://www.linkedin.com/in/d%C3%A1niel-cserp%C3%A1k-109057283/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/linkedin.png`}
              alt="LinkedIn"
              className="contact-image"
            />
          </a>
        </div>
      </div>

      <p className="footer-text">© {new Date().getFullYear()} Daniel Cserpak</p>
    </footer>
  );
};

export default Footer;
